var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"height":"100%"}},[_c('v-col',[_c('transition',{attrs:{"name":"fade-up","mode":"out-in","appear":""}},[_c('dashboard-index')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }